import React, { Component } from "react";
import * as Constants from "../../Constants/index";
import axios from "axios";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import Pagination from "react-js-pagination";
import swal from "sweetalert";
import { saveAs } from "file-saver";
import CreateCreateProgramManagers from "./createprogramManagers.component";
import CreateProgramManagers from "./createprogramManagers.component";

class ProgramManagers extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    // this.getFoodRequest = this.getFoodRequest.bind(this);
    // this.handleClickActiveTab = this.handleClickActiveTab.bind(this);
  }

  state = {
    name: "",
    sortBy: "id",
    sortAsc: false,
    limit: 25,
    totalResults: 0,
    page: 1,
    members: [],
    search: "",
    create: 0,
    view: 0,
    type: 'ADMIN,USER,COMPANY-USER,COMPANY-ADMIN,MK',
    isExporting: false
  };

  componentDidMount() {
    const currentURL = window.location.pathname;
    const parts = currentURL.split("/");
    let programid = parts.pop();
    programid = parseInt(programid);
    const pathSegments = window.location.pathname.split('/'); // Split the URL path by '/'
    let compid = pathSegments[pathSegments.length - 2];
    const SALESRequest = async () => {

      try {
        const token = localStorage.getItem("token");
        let url = "";
        this.state.search !== ""
          ? (url =
            "user/manage?" +
            "name=" +
            this.state.search +
            "&mobile=" +
            this.state.search +
            "&userType=" + this.state.type +
            "&sortBy=" +
            this.state.sortBy +
            "&sortAsc=" +
            this.state.sortAsc +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page)
          : (url =
            "user/manage?sortBy=" +
            this.state.sortBy +
            "&sortAsc=" +
            this.state.sortAsc +
            "&userType=" + this.state.type +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page);
        const resp = await axios
          .get(Constants.api + url, {
            headers: {
              Authorization: `Bearer ${token}`, company: compid, program: programid, appVersion: Constants.av,
              platform: Constants.pt
            },

          })
          .then((resp) => {
            //  SALESs array

            if (resp.status == 201 && resp.data.result !== "error") {
              // console.log(resp.data.output.results);
              this.setState({
                members: resp.data.output.results,
                totalResults: resp.data.output.totalResults,
              });
              console.log(this.state.members);
            } else if (resp.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
          }).catch((err) => {
            // window.location = "/login"
          });
      } catch (err) {
        // Handle Error Here
        console.error(err);
      }
    };
    SALESRequest();
  }

  searchHandleChange = (event) => {
    this.setState(
      { search: event.target.value, page: 1 },
      () => this.componentDidMount()
    );
  };

  limitHandleChange = (event) => {
    const limit = parseInt(event.target.value, 10);
    this.setState({ limit, page: 1 }, () => this.componentDidMount());
  };
  handleInputChange = (event) => {

    const target = event.target;
    const name = target.name;

    const value = target.value;

    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (name == 'type')

      this.setState(
        (prevState) => ({
          ...prevState,
          [name]: value,
        }),
        () => {
          this.componentDidMount()
        });


    else
      this.setState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };
  handlePageChange(pageNumber) {
    console.log(`active page is ${pageNumber}`);
    this.setState({ page: pageNumber }, () => this.componentDidMount());
  }
  handleViewMode = (data) => {
    this.setState({ create: data, resp: null });
    this.componentDidMount();
  };
  // setViewMode={this.handleViewMode}

  exportCSV = () => {
    this.setState({ isExporting: true });
    try {
      const currentURL = window.location.pathname;
      const parts = currentURL.split("/");
      let programid = parseInt(parts.pop(), 10) || 1;
      const pathSegments = window.location.pathname.split("/");
      let compid = parseInt(pathSegments[pathSegments.length - 2], 10) || 1;
      const token = localStorage.getItem("token");

      let url = `${Constants.api}user/download/managers?search=${encodeURIComponent(
        this.state.search || ""
      )}&userType=${encodeURIComponent(this.state.type || "")}`;

      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            company: compid,
            program: programid,
            appVersion: Constants.av || "1.3",
            platform: Constants.pt || "CMS",
          },
          responseType: "blob",
        })
        .then((res) => {
          this.setState({ isExporting: false });
          if (res.status === 200) {
            const fileData = new Blob([res.data], { type: "text/csv;charset=utf-8;" });
            saveAs(fileData, "ProgramManagers.csv");
          } else {
            swal({
              text: "Failed to download CSV",
              timer: 2000,
              buttons: false,
            });
          }
        })
        .catch((err) => {
          console.error("Export error:", err);
          this.setState({ isExporting: false });
          swal({
            text: "Error downloading managers CSV",
            timer: 2000,
            buttons: false,
          });
        });
    } catch (err) {
      console.error(err);
      this.setState({ isExporting: false });
    }
  };

  render() {

    const blockUser = (id) => {
      try {
        const token = localStorage.getItem("token");

        axios
          .patch(Constants.api + "user/update/block/" + id, "", {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("language"),
              appVersion: Constants.av,
              platform: Constants.pt,
            },
          })
          .then((resp) => {
            //  casetype array
            swal("Done");
            if (resp.status == 200) {
              this.setState({ verifyModal: false }, this.componentDidMount());
            } else if (resp.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
            //movie array
          })
          .catch((err) => {
            //  window.location = "/login"
          });
      } catch (err) {
        // Handle Error Here
        console.error(err);
      }
    };

    const activateUser = (id) => {
      try {
        const token = localStorage.getItem("token");

        axios
          .patch(
            Constants.api + "user/update/deactive/" + id, "",
            {
              headers: {
                Authorization: `Bearer ${token}`, "Accept-Language": localStorage.getItem("language"), appVersion: Constants.av,
                platform: Constants.pt
              },
            },

          )
          .then((resp) => {
            //  casetype array
            swal("Done")
            if (resp.status == 200) {
              this.componentDidMount()

            } else if (resp.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
            //movie array
          }).catch((err) => {
            //  window.location = "/login"
          });
      } catch (err) {
        // Handle Error Here
        console.error(err);
      }
    };

    const editItem = (id) => {
      try {
        const token = localStorage.getItem("token");
    
        axios
          .get(`${Constants.api}user/manage/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("language"),
            },
          })
          .then((resp) => {
            if (resp.status === 200) {
              this.setState({ create: 1, resp: resp });
            } else if (resp.status === 403) {
              localStorage.clear();
              window.location.href = "/";
            }
          })
          .catch((err) => {
            console.error(err);
            // You can redirect or show an error message here if needed
          });
      } catch (err) {
        console.error(err);
      }
    };
    

    // const editItem = (id) => {
    //   try {
    //     const token = localStorage.getItem("token");
    //     const deletedata = new FormData();
    //     deletedata.append("id", id); //append the values with key, value pair

    //     axios
    //       .get(
    //         Constants.api + "user/manage/" + id,
    //         {
    //           headers: { Authorization: `Bearer ${token}`, "Accept-Language": localStorage.getItem("language") },
    //         },
    //         deletedata
    //       )
    //       .then((resp) => {
    //         //  casetype array

    //         if (resp.status == 200) {
    //           this.setState({ create: 1, resp: resp });
    //         } else if (resp.status == 403) {
    //           localStorage.clear();
    //           window.location.href = "/";
    //         } else {
    //         }
    //         //movie array
    //       }).catch((err) => {
    //         //  window.location = "/login"
    //       });
    //   } catch (err) {
    //     // Handle Error Here
    //     console.error(err);
    //   }
    // };

    const viewItem = (id) => {
      try {
        const token = localStorage.getItem("token");
        const deletedata = new FormData();
        deletedata.append("id", id); //append the values with key, value pair

        axios
          .get(
            Constants.api + "user/manage/" + id,
            {
              headers: { Authorization: `Bearer ${token}`, "Accept-Language": localStorage.getItem("language") },
            },
            deletedata
          )
          .then((resp) => {
            //  casetype array

            if (resp.status == 200) {
              this.setState({ view: 1, create: 1, resp: resp });
            } else if (resp.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
            //movie array
          }).catch((err) => {
            //  window.location = "/login"
          });
      } catch (err) {
        // Handle Error Here
        console.error(err);
      }
    };
    const deleteItem = (id) => {
      if (window.confirm("Are you sure?")) {
        try {
          const token = localStorage.getItem("token");
          const deletedata = new FormData();
          deletedata.append("id", id); //append the values with key, value pair

          axios
            .delete(
              Constants.api + "user/manage/" + id,
              {
                headers: { Authorization: `Bearer ${token}`, "Accept-Language": localStorage.getItem("language") },
              }


            )
            .then((resp) => {
              //  casetype array

              if (resp.status == 200) {
                this.componentDidMount();
              } else if (resp.status == 403) {
                localStorage.clear();
                window.location.href = "/";
              } else {
              }
              //movie array
            });
        } catch (err) {
          // Handle Error Here
          console.error(err);
        }
      }
    };

    const membersRender = this.state.members.map(function (item, i) {
      return (
        <>
          <tr>
            <td>
              {item.name || ""}
            </td>
            <td>
              <p>{item.mobile || ""}</p>
            </td>
            <td>
              <p>{item.userType || ""}</p>
            </td>
            {/* <td class="date_two">
              {item.createdDateTime}
            </td> */}
            {/* <td>
              <p>{item.designation}</p>
            </td> */}

            {/* <td>
              <p onClick={() => editItem(item.parentId)}> View &nbsp; <i class="material-icons text-lg">visibility</i> </p>
            </td> */}

            

            <td>
              {/* {(item.active) ?
                <button class="btn btn-outline-primary btn-sm" onClick={() => activateUser(item.id)}
                ><i class="material-icons text-lg">check_circle</i> Active</button>
                :
                <button class="btn btn-outline-primary btn-sm" onClick={() => activateUser(item.id)}
                ><i class="material-icons text-lg">cancel</i> Deactivate</button>
              } */}

              {item.deleted ? (
                <button
                  class="btn btn-outline-primary btn-sm"
                  onClick={() => blockUser(item.id)}
                >
                  <i class="material-icons text-lg">check_circle</i> Block
                </button>
              ) : (
                <button
                  class="btn btn-outline-primary btn-sm"
                  onClick={() => blockUser(item.id)}
                >
                  <i class="material-icons text-lg">cancel</i> Unblock
                </button>
              )}

              <button class="btn btn-outline-primary btn-sm" onClick={() => editItem(item.id)}
              ><i class="material-icons text-lg">edit</i> Edit</button>
              &nbsp;
            </td>

            
          </tr>
        </>
      );
    });

    return (
      <>
        {this.state.create == 0 ? (
          <>

            <main class="">
              <nav class="navbar navbar-main navbar-expand-lg position-sticky mt-4 top-1 px-0 mx-4 shadow-none border-radius-xl z-index-sticky" id="navbarBlur" data-scroll="true">
                <div class="container-fluid py-1 px-3">
                  <nav aria-label="breadcrumb">
                    <ul class="navbar-nav  justify-content-end">
                      <li class="nav-item">
                        <div class="from_dropdown">
                          <label for="show">Type</label>
                          <select class="form-control" name="type" id="show" onChange={(e) =>
                            this.handleInputChange(e)
                          } >
                            <option
                              value="ADMIN,USER,COMPANY-USER,COMPANY-ADMIN,MK"

                            >
                              All
                            </option>
                            <option
                              value="Admin"

                            >
                              ADMIN
                            </option>
                            <option
                              value="Sales"

                            >
                              Sales
                            </option>

                            <option
                              value="SH"

                            >
                              Sales Head
                            </option>
                            <option
                              value="RO"

                            >
                              RO
                            </option>
                            <option
                              value="HO"

                            >
                              HO
                            </option>
                            <option
                              value="ZO"

                            >
                              ZO
                            </option>


                          </select>
                        </div>
                      </li>

                    </ul>
                  </nav>
                  <div class="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
                    <a class="nav-link text-body p-0">

                    </a>
                  </div>
                  <div class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
                    <div class="ms-md-auto pe-md-3 d-flex align-items-center">
                      <div class="input-group input-group-outline">
                        <input type="text" class="form-control" placeholder="Search"
                          onChange={this.searchHandleChange} />
                      </div>
                    </div>
                    <ul class="navbar-nav  justify-content-end">
                      <li class="nav-item">
                        <div class="from_dropdown">
                          <label for="show">Show entries</label>
                          <select name="cars" id="show" value={this.state.limit} onChange={this.limitHandleChange}>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                          </select>
                        </div>
                      </li>

                    </ul>
                  </div>
                </div>
              </nav>
              <div class="container-fluid py-4">
                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-header pb-0">
                        <div class="d-lg-flex">
                          <div>
                            <h5 class="mb-0"> Program Managers</h5>

                          </div>
                          <div class="ms-auto my-auto mt-lg-0 mt-4">
                            <div class="ms-auto my-auto d-flex align-items-center">
                              <button
                                type="button"
                                class="btn btn-outline-primary mb-2 me-2"
                                onClick={this.exportCSV}
                                disabled={this.state.isExporting}
                              >
                                <i class="material-icons position-relative text-md pe-1">file_download</i>
                                {this.state.isExporting ? "Exporting..." : "Export CSV"}
                              </button>
                              <a href="#" class="btn bg-gradient-primary mb-2" onClick={() => this.setState({ create: 1, resp: null })}
                              > <i class="material-icons text-white position-relative text-md pe-2">add</i> Add New</a>
                              <div class="modal fade" id="import" tabindex="-1" aria-hidden="true">
                                <div class="modal-dialog mt-lg-10">
                                  <div class="modal-content">
                                    <div class="modal-header">
                                      <h5 class="modal-title" id="ModalLabel">Import CSV</h5>
                                      <i class="material-icons ms-3">file_upload</i>
                                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div class="modal-body">
                                      <p>You can browse your computer for a file.</p>
                                      <div class="input-group input-group-dynamic mb-3">
                                        <label class="form-label">Browse file...</label>
                                        <input type="email" class="form-control" onfocus="focused(this)" onfocusout="defocused(this)" />
                                      </div>
                                      <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="importCheck" checked="" />
                                        <label class="custom-control-label" for="importCheck">I accept the terms and conditions</label>
                                      </div>
                                    </div>
                                    <div class="modal-footer">
                                      <button type="button" class="btn bg-gradient-secondary btn-sm" data-bs-dismiss="modal">Close</button>
                                      <button type="button" class="btn bg-gradient-primary btn-sm">Upload</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* <button class="btn btn-outline-primary btn-sm export mb-0 mt-sm-0 mt-1" data-type="csv" type="button" name="button">Export</button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body px-0 pb-0">
                        <div style={{ overflowX: "auto", minHeight: "300px", maxHeight: "550px" }}>
                          <table className="table table-flush text-nowrap" id="products-list" style={{ minWidth: "1600px" }}>
                            <thead className="thead-light">
                              <tr>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Email</th>
                                <th>Pincode</th>
                                <th>Sales User Type</th>
                                <th>Parent</th>
                                <th>Cluster</th>
                                <th>Territory</th>
                                <th>Zone</th>
                                <th>Headquarter</th>
                                <th>Designation</th>
                                <th>HQ Designation</th>
                                <th style={{ minWidth: "180px", textAlign: "center" }}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.members.map((item, i) => (
                                <tr key={i}>
                                  <td>{item.name || "-"}</td>
                                  <td>{item.mobile || "-"}</td>
                                  <td>{item.email || "-"}</td>
                                  <td>{item.spincode || "-"}</td>
                                  <td>{item.salesUserType || item.userType || "-"}</td>
                                  <td>{item.parentName || (item.parentId && item.parentId !== 0 ? item.parentId : "-")}</td>
                                  <td>{item.cluster || "-"}</td>
                                  <td>{item.territory || "-"}</td>
                                  <td>{item.zone || "-"}</td>
                                  <td>{item.headquater || "-"}</td>
                                  <td>{item.designation || "-"}</td>
                                  <td>{item.hqDesignation || "-"}</td>
                                  <td style={{ minWidth: "180px", textAlign: "center" }}>
                                    {item.deleted ? (
                                      <button
                                        className="btn btn-outline-primary btn-sm mb-0"
                                        onClick={() => blockUser(item.id)}
                                      >
                                        <i className="material-icons text-lg">check_circle</i> Block
                                      </button>
                                    ) : (
                                      <button
                                        className="btn btn-outline-primary btn-sm mb-0"
                                        onClick={() => blockUser(item.id)}
                                      >
                                        <i className="material-icons text-lg">cancel</i> Unblock
                                      </button>
                                    )}
                                    &nbsp;
                                    <button
                                      className="btn btn-outline-primary btn-sm mb-0"
                                      onClick={() => editItem(item.id)}
                                    >
                                      <i className="material-icons text-lg">edit</i> Edit
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>

          
            </main>
            <div className="pagination-container">
              <Pagination
                activePage={this.state.page}
                itemsCountPerPage={this.state.limit}
                totalItemsCount={this.state.totalResults}
                pageRangeDisplayed={20}
                onChange={this.handlePageChange.bind(this)}
              />
            </div>
          </>
        ) : this.state.resp ? (

          <CreateCreateProgramManagers
            key={this.state.resp?.data?.output?.id || 'edit'}
            resp={this.state.resp} setViewMode={this.handleViewMode} />
        ) : (
          <CreateCreateProgramManagers 
            key="new"
            setViewMode={this.handleViewMode}
          />
        )}

      </>
    );
  }
}

export default ProgramManagers;
